import api from './api';

export interface Responsavel {
  id: string;
  nome: string;
  cpf: string;
  cargo: string | null;
  email?: string | null;
  telefone?: string | null;
  ativo: boolean;
}

export type ResponsavelInput = Partial<Omit<Responsavel, 'id'>>;

const ENDPOINT = '/industrializacao/responsavel';

const responsavelService = {
  async listar(): Promise<Responsavel[]> {
    const response = await api.get<Responsavel[]>(ENDPOINT);
    return response.data;
  },
  async buscarPorId(id: string): Promise<Responsavel> {
    const response = await api.get<Responsavel>(`${ENDPOINT}/${id}`);
    return response.data;
  },
  async criar(data: ResponsavelInput): Promise<Responsavel> {
    const response = await api.post<Responsavel>(ENDPOINT, data);
    return response.data;
  },
  async atualizar(id: string, data: ResponsavelInput): Promise<Responsavel> {
    const response = await api.put<Responsavel>(`${ENDPOINT}/${id}`, data);
    return response.data;
  },
  async excluir(id: string): Promise<void> {
    await api.delete(`${ENDPOINT}/${id}`);
  },
};

export default responsavelService;
